import {AbstractModel} from '../abstract-model';
import {TranslationDomain} from './translation-domain';

export class TranslationMessage extends AbstractModel {
  domain: TranslationDomain | null = null;
  locale: string | null = null;
  key: string | null = null;
  text: string | null = null;
  error: any | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.domain) {
      this.domain = new TranslationDomain().deserialize(input.domain);
    }

    return this;
  }
}
